module.exports = "https://cdn.realtymogul.com/static/media/table_compare.4ca597cc.png";